exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".day-month-year-picker p[data-v-5badb010]{font-size:12px;padding:8px 20px;padding-bottom:0}.age-verification-section .verfication-form .day-month-year-picker select[data-v-5badb010]{height:32px;padding-top:0}.control.select.is-full-width.pr-5[data-v-5badb010]{padding-right:25px}", ""]);

// exports
